import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { experienceService } from '../services/experience.service';
import type { Experience } from '../types/experience.types';

interface DeleteExperienceData {
  candidateId: string;
  experienceId: string;
}

type DeleteMutation = UseMutationResult<Experience, Error, DeleteExperienceData>;

interface UseDeleteExperienceReturn {
  deleteExperience: DeleteMutation['mutate'];
  deleteExperienceAsync: DeleteMutation['mutateAsync'];
  isLoading: boolean;
  isError: boolean;
  isSuccess: boolean;
  error: Error | null;
  reset: () => void;
}

export function useDeleteExperience(): UseDeleteExperienceReturn {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (data: DeleteExperienceData) =>
      experienceService.deleteExperience(data.candidateId, data.experienceId),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['experiences', { candidateId: variables.candidateId }],
      });
    },
  });

  return {
    deleteExperience: mutation.mutate,
    deleteExperienceAsync: mutation.mutateAsync,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    error: mutation.error,
    reset: mutation.reset,
  };
}
